import { useCallback, useEffect, useRef } from 'react'

export interface IQuarterProgress {
  progress: number
  currentVideoTime: number
}

const QUARTERS = [25, 50, 75, 100]

/**
 * Dedupe de progresso por quarter (25/50/75/100), espelhando o legado web/core.
 * Retorna `report(currentTime, duration)` que só dispara `onProgress` quando um
 * novo quarter é atingido, evitando floodar a mutation de progresso.
 *
 * `resetKey` (ex.: id da mídia) reinicia o controle ao trocar de aula.
 */
export function useQuarterProgressReporter(
  onProgress: (params: IQuarterProgress) => void,
  resetKey?: string | number,
) {
  const lastQuarterRef = useRef(0)

  useEffect(() => {
    lastQuarterRef.current = 0
  }, [resetKey])

  return useCallback(
    (currentTime: number, duration: number) => {
      if (!duration || duration <= 0) return
      const progress = Math.round((currentTime / duration) * 100)
      const quarter = QUARTERS.filter((q) => progress >= q).pop() ?? 0
      if (quarter > lastQuarterRef.current) {
        lastQuarterRef.current = quarter
        onProgress({
          progress: quarter,
          currentVideoTime: Math.floor(currentTime),
        })
      }
    },
    [onProgress],
  )
}
